import { useContext } from "react";
import constants from "../../constants";
import useAxiosPrivate from "../useAxiosPrivate";
import AlertContext from "../../context/AlertContext";
import StudentTestPageHooks from "./StudentTestPageHooks";
import useCommonFunctionHooks from "../useCommonFunctionHooks";
// import useUploadLargeFileToS3 from "../useUploadLargeFileToS3";
import CreateSchemaTableHooks from "../CreateSchemaTableHooks";
import { getDataFromStorage } from "../../util";
import StudentTestPageCalcStatsHooks from "./StudentTestPageCalcStatsHooks";
import { streamToUint8Array } from "../../Components/CommonComponents/PdfViewer";
import useS3FileManagement from "../useS3FileManagement";
import * as axiosPublic from "../../api/axios";

// import { StudentTestPageContext } from "../../context/StudentTestPageContext";

export default function StudentTestAdminHooks() {
  const Alert = useContext(AlertContext);
  const { getPreSignedUrl, getS3Object } = useS3FileManagement();
  // const {fSections, setFSections} = useContext(StudentTestPageContext);

  let { calcStats } = StudentTestPageCalcStatsHooks();
  let { uRole, tempReport, handleVideoQuestions } = StudentTestPageHooks();

  const axios = useAxiosPrivate();
  // const { getS3Object } = useUploadLargeFileToS3();
  const { parseCreateTable } = CreateSchemaTableHooks();

  const { getCatchBlockDetails, getHeaderDetailsForAxios } =
    useCommonFunctionHooks();

  const handleMcq = (
    testid,
    lpid,
    lpconfigid,
    status,
    learnerid,
    proctored,
    testmode,
    configdata,
    learnerlist,
    fromreport,
    cellobj,
    libtypeid,
    viewTest,
    autoEval,
  ) => {
    let testData = {
      lpid: lpid,
      testid: testid,
      status: status,
      cellobj: cellobj,
      autoEval: autoEval,
      testmode: testmode,
      viewTest: viewTest,
      learnerid: learnerid,
      proctored: proctored,
      libtypeid: libtypeid,
      configdata: configdata,
      lpconfigid: lpconfigid,
    };

    if (typeof testid === "object") {
      testData = testid;
    }

    if (
      Alert.isFromProfile.current ||
      getDataFromStorage("role") === "customer" ||
      (Alert.isAdmin && !Alert.isFromProfile.current)
    ) {
      Alert.setLearnerId(learnerid);
      Alert.setFromReport(fromreport);
      Alert.setTestId(testid);
    }

    Alert.setMcqAndDesTestAndLpId(testData);

    Alert.setTakeMcqAndDesTest(true);
    if (
      (Alert.isAdmin ||
        Alert.isFromProfile.current ||
        testData.cellobj.from === "learner" ||
        getDataFromStorage("role") === "customer") &&
      testData.status !== constants.PROGRESS_STATUS.UNLOCKED
    ) {
      handleAdminView(testData);
    }
  };

  const fetchVideoData = async (path) => {
    try {
      let url;

      if (process.env.REACT_APP_DEPLOYMENT === "LOCAL") {
        url = { url: process.env.REACT_APP_NODE_API + path };
      } else {
        // const result = await getS3Object(
        //   path,
        //   undefined,
        //   "arraybuffer"
        // );
        const { url: signedUrl } = await getPreSignedUrl(
          path,
          undefined,
          path?.split(".")?.pop(),
          "GET",
        );

        const result = await axiosPublic.default({
          method: "GET",
          url: signedUrl,
          responseType: "arraybuffer",
        });

        // const uint8Array = await streamToUint8Array(result);
        const blob = new Blob([result.data], { type: "video/mp4" });

        url = URL.createObjectURL(blob);
        // url = signedUrl;
      }

      return url;
    } catch (error) {
      console.error("Error fetching Video data:", error);
    }
  };

  const handleAdminView = async (testData) => {
    try {
      if (
        Alert.isFromProfile.current ||
        testData.cellobj.from === "learner" ||
        getDataFromStorage("role") === "customer" ||
        (Alert.isAdmin && !Alert.isFromProfile.current)
      ) {
        Alert.hasRendered.current = false;
      }
      if (!Alert.hasRendered.current) {
        Alert.hasRendered.current = true;

        Alert.setIsLoaded(true);
        Alert.setIsTakeTest(false);
        const { data } = await axios.post(
          "node/learner/course/test/report",
          {
            lpid: testData.lpid,
            testid: testData.testid,
            learnerid: testData.learnerid,
            libtypeid: testData.libtypeid,
            lpconfigid: testData.lpconfigid,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
        );

        Alert.backupTestDataq.current = data.data;
        if (data.resultCode !== constants.RESULT_STATUS.SUCCESS) {
          Alert.setShowNotify({
            show: true,
            title: "Info",
            msg: data.message,
          });
          return;
        }
        if (testData.libtypeid === constants.libTypeIds.SQL) {
          data.data.sections[0].questions = data.data.sections[0].questions.map(
            ({ actualscore, targetscore, answer, ...rest }, _, arr) => ({
              ...rest,
              solution: answer,
              actualscore,
              targetscore,
            }),
          );
          const hasAnyNewVersion = data.data?.sections?.some(section =>
            section.questions.some(q => q.hasNewVersion === 1 && !q.isFixedQn)
          );
          const newVersionQuestions = data.data?.sections?.flatMap(section =>
            section.questions.filter(q => q.hasNewVersion === 1 && !q.isFixedQn)
          );
          Alert.setRejectData({
            duration: data.data.duration,
            timeleft: data.data.timeleft,
            remaingQnCount: data.data.remaingQnCount,
            libtypeid: testData.libtypeid,
            hasAnyNewVersion,
            newVersionQuestions
          });

          Alert.setTestDetail(() => ({
            ...data,
            libtypeid: testData.libtypeid,
            currentIndex: 0,
            data: data.data,
            ...(data.data.sections[0]?.questions[0] || {}),
            totalQn: data.data.sections[0]?.questions.length,
            schema: parseCreateTable(
              data.data.sections[0]?.questions[0].dbSchema,
            ),
            language: [
              {
                value: 1,
                label: "SQL",
              },
            ],
            selectedLanguage: {
              value: 1,
              label: "SQL",
            },
          }));
          Alert.setCommentsData(data?.data?.commentsdata ?? []);

          Alert.navigate("/sql");
        } else {
          tempReport = data.data;
          if (tempReport.videoqn === 1) {
            handleVideoQuestions(tempReport.sections);
          }

          Alert.setTestDetail({
            ...data.data,
            libtypeid: testData.libtypeid,
          });
          Alert.setTsCoBkup({});
          Alert.setDescScores({});
          Alert.setApiLoaded(true);
          Alert.setMcqTestData(data.data);
          calcStats(tempReport, ["all"]);
          Alert.updateComingObj(data.data);
          clearInterval(Alert.interval.current);
          Alert.setBackupTestData(data.data);
          Alert.setTestMode(data.data.testmode);
          Alert.updateQuestionContainerSingle(false);
          Alert.backupTestDataq.current = data.data;
          Alert.setCommentsData(data.data.commentsdata);
          const hasAnyNewVersion = data.data?.sections?.some(section =>
            section.questions.some(q => q.hasNewVersion === 1 && !q.isFixedQn)
          );
          console.log("data.data?.sections", data.data?.sections);
          
          const newVersionQuestions = data.data?.sections?.flatMap(section =>
            section.questions.filter(q => q.hasNewVersion === 1 && !q.isFixedQn)
          );

          console.log("hasAnyNewVersion",hasAnyNewVersion,"newVersionQuestions",newVersionQuestions );
          

          Alert.setRejectData({
            duration: data.data.duration,
            timeleft: data.data.timeleft,
            remaingQnCount: data.data.remaingQnCount,
            isFixedQn: data.data.hasFixedQns,
            libtypeid: testData.libtypeid,
            hasAnyNewVersion: hasAnyNewVersion,
            newVersionQuestions: newVersionQuestions
          });
          Alert.setTestPageShow(true);

          for (let i = 0; i < data.data.sections.length; i++) {
            for (let j = 0; j < data.data.sections[i].questions.length; j++) {
              if (process.env.REACT_APP_DEPLOYMENT === "AWS") {
                let question = data.data.sections[i].questions[j];

                if (uRole === "learner") {
                  question.review = -1;
                }

                for (let k = 0; k < question.links.length; k++) {
                  let linkRes = await getPreSignedUrl(
                    question.links[k].link,
                    undefined,
                    question.links[k].link?.split(".")?.pop(),
                    "GET",
                  );
                  question.links[k].link = linkRes.url;
                }

                if (tempReport.videoqn === 1) {
                  if (
                    data.data.sections[i].questions[j].answer !== "" &&
                    data.data.sections[i].questions[j].answer != null
                  ) {
                    // let videoRes = await fetchVideoData(
                    //   data.data.sections[i].questions[j].answer,
                    // );

                    // data.data.sections[i].questions[j].answer = videoRes;
                    Alert.updateComingObj(data.data);
                  }
                }
              }

              if (
                data.data.sections.length - 1 === i &&
                data.data.sections[i].questions.length - 1 === j
              ) {
                if (tempReport.videoqn === 1)
                  Alert.setTestPageShowReload((prevState) => !prevState);
              }
            }
          }
          Alert.navigate("/mcq");
        }
      }
    } catch (error) {
      getCatchBlockDetails(error);
    } finally {
      Alert.setIsLoaded(false);
    }
  };

  return { handleMcq };
}
